<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <strong slot="left-title">Création d'un Accès Externe</strong>
    </sticky>
    <div class="columns is-gapless is-padding-top is-margin-left-on-btn-actions is-margin-right-on-btn-actions">
      <div class="column is-12 is-8-widescreen is-7-fullhd is-paddingless">
        <div class="has-bg-white is-border">
          <external-access-form @failed="submitFailed" @submit="submit" :loading="loading"></external-access-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ExternalAccessForm from '@/components/external-access/ExternalAccessForm'
  import { Error } from '@/mixins'
  export default {
    name: 'ExternalAccessCreate',
    mixins: [Error],
    components: {
      ExternalAccessForm
    },
    props: {},
    data () {
      return {
        loading: false
      }
    },
    computed: {},
    methods: {
      submitFailed (access) {

      },
      submit (access) {
        this.loading = true
        this.$api.externalAccessService.post(access)
          .then(res => {
            this.loading = false
            this.$router.push({name: 'ExternalAccessList'})
          })
          .catch((err) => {
            this.handleError(err, 'Erreur lors de la création de l\' accès.')
            this.loading = false
          })
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/external-access/ExternalAccessCreate.vue